import { forwardRef } from 'react';
import type { Theme } from '../types';
import { CreateThemeButton } from './CreateThemeButton';
import { SelectInput } from './SelectInput';
import { SelectOption } from './SelectOption';

type Props = {
  /** Array of theme options to display */
  items: Theme[];
  /** Whether to show the create theme button */
  showCreateButton?: boolean;
  /** Callback when create theme button is clicked */
  onCreateClick?: () => void;
};

const SelectMenuComponent = ({ items, showCreateButton, onCreateClick }: Props, ref: React.Ref<HTMLDivElement>): React.JSX.Element => {
  return (
    <SelectInput>
      <div ref={ref}>
        {items.map(x =>
          <SelectOption
            editable={x.editable}
            item={x}
            key={x.id} />)}
        {showCreateButton && onCreateClick && (
          <CreateThemeButton onClick={onCreateClick} />
        )}
      </div>
    </SelectInput>
  );
};

SelectMenuComponent.displayName = 'ChartTheming.SelectMenu';

export const SelectMenu = forwardRef(SelectMenuComponent);
